@if (result != undefined) {
  <div class="mt-10">
    <b>Result</b>
    @if (result.compileError.length > 0) {
      <div class="text-[#A10404] whitespace-pre-wrap">
        ERROR: {{result.compileError.join('\n')}}
      </div>
    }
    @if (result.compileError.length === 0) {
      <div [ngClass]="theme.includes('dark') || theme.includes('black')? 'bg-[#212121] rounded-[6px] text-white p-5':'border border-[#E5E5E5] text-[#3B3B3B] rounded-[6px] p-5'">
        <div class="grid grid-cols-4 gap-4">
          @if (theme.includes('dark') || theme.includes('black')) {
            <div class="flex flex-col items-start">
              @for (case of result.cases; track case; let i = $index) {
                <button
                  [ngClass]="selectedIndex === i? 'p-[8px] rounded-r-[6px] bg-[#4D4C4C] mb-1':'p-[8px] rounded-r-[6px] hover:bg-[#4D4C4C] mb-1'"
                  (click)="changeCase(case, i)"
                  >
                  @if (case.correctness) {
                    <fa-icon [icon]="faCheck" class="text-[#1AC69C] mr-1" />
                  }
                  @if (!case.correctness) {
                    <fa-icon [icon]="faXmark" class="text-[#A10404] mr-1" />
                  }
                  Case {{i+1}}
                  @if (case.correctness) {
                    <span> - Passed</span>
                  }
                  @if (!case.correctness) {
                    <span> - Failed</span>
                  }
                </button>
              }
            </div>
          }
          @if (theme.includes('light')) {
            <div class="flex flex-col items-start">
              @for (case of result.cases; track case; let i = $index) {
                <button
                  [ngClass]="selectedIndex === i? 'p-[8px] rounded-r-[6px] bg-[#E5E5E5] mb-1':'p-[8px] rounded-r-[6px] hover:bg-[#E5E5E5] mb-1'"
                  (click)="changeCase(case, i)"
                  >
                  @if (case.correctness) {
                    <fa-icon [icon]="faCheck" class="text-[#1AC69C] mr-1" />
                  }
                  @if (!case.correctness) {
                    <fa-icon [icon]="faXmark" class="text-[#A10404] mr-1" />
                  }
                  Case {{i+1}}
                  @if (case.correctness) {
                    <span> - Passed</span>
                  }
                  @if (!case.correctness) {
                    <span> - Failed</span>
                  }
                </button>
              }
            </div>
          }
          @if (selectedCase != undefined) {
            <div>
              <b>Input</b><br/>
              <p class="text-[#B8B8B8] break-words whitespace-pre-wrap">{{selectedCase.input.join('\n')}}</p>
            </div>
          }
          @if (selectedCase != undefined) {
            <div>
              <b>Expected Output</b><br/>
              <p class="text-[#B8B8B8] break-words whitespace-pre-wrap">{{selectedCase.expectedOutput.join('\n')}}</p>
            </div>
          }
          @if (selectedCase != undefined) {
            <div>
              <b>Your Output</b><br/>
              <p [ngClass]="selectedCase.correctness? 'text-[#1AC69C]':'text-[#E70202]'" class="break-words whitespace-pre-wrap">
                {{selectedCase.output.join('\n')}}
              </p>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
